import axios from 'axios';

export const getNews = paginationParams => axios.get('/news/', { params: { ...paginationParams } });

export const getAnalyticReviews = paginationParams =>
  axios.get('/news/analytic_reviews/', { params: { ...paginationParams } });
